module.exports = __webpack_public_path__ + "SC02_03.c10b7938.atlas";